import { call, all } from 'redux-saga/effects'

import { checkMetaMaskSaga, buyerSagas, walletSagas, campaignPublicSagas } from 'primsell-shared-layer/features'
import { stripeSagas, orderSagas, paymentSagas } from 'features'

function* rootSaga(): Generator {
  yield all([
    call(checkMetaMaskSaga),
    orderSagas(),
    buyerSagas(),
    stripeSagas(),
    walletSagas(),
    campaignPublicSagas(),
    paymentSagas(),
  ])
}

export { rootSaga }
